@if (camera?.status === ConnectivityState.Offline) {
	<img alt="{{ T.MJPEG_STATE_OFFLINE | translate }}" style="position: absolute" [src]="settings.offlineVideoUrl" />
}

@if (!mjpegVideoOptions?.cameraId || mjpegVideoOptions?.cameraId === SimUtilityService.emptyGuid()) {
	<img style="position: absolute" alt="{{ T.MJPEG_STATE_NO_VIDEO | translate }}" [src]="settings.noVideoUrl" />
}

<div #mjpegVideoContainer>
	@if (settings.axisVideoPlayerEnableDebugWindow) {
		<div class="mjpeg-video-player-debug-container">
			{{ T.SHARED_MJPEG_IMAGE_ADDRESS | translate }}
			{{ mjpegVideoOptions?.ipAddress }}<br />
			{{ T.SHARED_MJPEG_IMAGE_URL | translate }} {{ mjpegVideoOptions?.url }}<br />
			{{ T.SHARED_MJPEG_IMAGE_STATUS | translate }} {{ camera?.status }}<br />
			{{ T.SHARED_MJPEG_IMAGE_ROTATION_SUPPORTED | translate }}
			{{ camera?.rotationSupported }}
		</div>
	}
	@if (camera?.status === ConnectivityState.Online) {
		<img #mjpegImage [src]="mjpegVideoOptions?.url" alt="{{ T.MJPEG_STATE_RESULT | translate }}" />
	}
</div>
